var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('div',{class:_vm.$style.tab},_vm._l((_vm.tab),function(item,i){
var _obj;
return _c('div',{key:i,class:[_vm.$style.tabtext,
        'clickCss',
        ( _obj = {}, _obj[_vm.$style.activetext] = item.link === _vm.navVal, _obj )],on:{"click":function($event){return _vm.navFunction(item.link)}}},[_vm._v(" "+_vm._s(item.text)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }